import GuardianService from '@/services/GuardianService'
import Vue from 'vue'
import { VAutocomplete } from 'vuetify/lib'

export const SelectFrachise = Vue.component('SelectFrachise', {
	name: 'SelectFrachise',
    data: () => ({
        franchiseId: -1,
        franchiseList: new Array()
    }),

    async beforeMount()
    {
        this.franchiseList = await GuardianService.getAllFranchise()
    },

    render() {
        return(
            <div>
                <VAutocomplete
                    itemValue="id"
                    itemText="nome"
                    vModel={this.franchiseId}
                    items={this.franchiseList}
                    class="ma-0"
                    placeholder="Selecione a franquia"
                />
            </div>
        )
    },

    watch: {
		franchiseId: {
			handler() {
				this.$emit('franchiseChange', this.franchiseId)
			}
		}
	},
})